import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatureFlag, useFeatureFlags } from '../../hooks/useFeatureFlag';

interface FeatureFlagRouteProps {
  flag?: string; // Single flag (for backward compatibility)
  flags?: string[]; // Multiple flags with OR logic
  children: React.ReactNode;
  redirectTo?: string;
}

export const FeatureFlagRoute: React.FC<FeatureFlagRouteProps> = ({
  flag,
  flags,
  children,
  redirectTo = '/dashboard',
}) => {
  // Support both single flag and multiple flags
  // If flags array is provided, use OR logic (any flag enabled = allow access)
  // Otherwise, use single flag (backward compatible)
  const isEnabled = flags 
    ? useFeatureFlags(flags)
    : flag 
      ? useFeatureFlag(flag)
      : false;

  if (!isEnabled) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

